"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FleetPortalAPI = function () {
  function FleetPortalAPI($http, $window, config) {
    _classCallCheck(this, FleetPortalAPI);

    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  _createClass(FleetPortalAPI, [{
    key: "get",
    value: function get(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.get("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "post",
    value: function post(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.post("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "put",
    value: function put(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.put("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.delete("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var userString = this.$window.sessionStorage["userAuthInfo"];
      var user = JSON.parse(userString);

      var options = {
        headers: {
          "ALK-Language": undefined,
          "Authorization": "Bearer " + user.authToken
        }
      };

      return options;
    }
  }, {
    key: "getPagingQuery",
    value: function getPagingQuery(paging) {
      if (!paging) return [];

      var p = [];
      if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
      if (paging.limit != null) p.push("limit=" + paging.limit);
      if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
      if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);

      return p;
    }
  }, {
    key: "getArrayQuery",
    value: function getArrayQuery(key, arr) {
      if (arr == null) return [];

      var p = [];

      if (this.isArray(arr)) {
        for (var i = 0; i < arr.length; i++) {
          p.push(key + "=" + arr[i]);
        }
      } else {
        // if passed in item is not an array, but instead a single item
        p.push(key + "=" + arr);
      }

      return p;
    }
  }, {
    key: "isArray",
    value: function isArray(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    }
  }]);

  return FleetPortalAPI;
}();

exports.default = FleetPortalAPI;


FleetPortalAPI.$inject = ["$http", "$window", "alk.fleetportal.config"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.api.js